export  const SkillsData=[
    {
        type:"Frontend",
        list:[
           {
               name:"ReactJs",
               icon:<i class="devicon-react-original colored"></i>

           },
           {
            name:"Javascipt",
            icon:<i class="devicon-javascript-plain colored"></i>
           
           },
           {
            name:"Html5",
            icon: <i class="devicon-html5-plain colored"></i>
            
           },
           {
            name:"CSS3",
            icon:<i class="devicon-css3-plain colored"></i>
            
           },
        ],

    },
    {
            type:"Backend",
            list:[
                {
                    name:"MongoDB",
                    icon:<i class="devicon-mongodb-plain-wordmark colored"></i>
                },
                {
                    name:"Node.js",
                    icon:<i class="devicon-nodejs-plain colored"></i>
                }
            ]
    





     }

] 